"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumView = void 0;
/**
 * The View that the event is sent from. For example, if the user is on the dashboard and click on a message, we would  set the Feature as \'Messaging\' and the View as \'Dashboard\'.
 */
exports.EnumView = {
    Dashboard: 'Dashboard',
    MessagingCompose: 'MessagingCompose',
    MessagingDetail: 'MessagingDetail',
    MessagingImportant: 'MessagingImportant',
    MessagingInbox: 'MessagingInbox',
    MessagingSent: 'MessagingSent',
    MessagingTrash: 'MessagingTrash',
    DocumentsList: 'DocumentsList',
    AfterVisitSummaryList: 'AfterVisitSummaryList',
    NotMapped: 'NotMapped',
};
//# sourceMappingURL=enum-view.js.map